import { motion } from "framer-motion";
import { useI18n } from "@/i18n/LanguageContext";

const EASE = [0.16, 1, 0.3, 1];

export default function Process() {
  const { t } = useI18n();
  const p = t.process;

  return (
    <section id="processus" className="border-y border-pine/10 bg-creamd">
      <div className="mx-auto max-w-7xl px-4 py-24 sm:px-8 md:py-36">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: EASE }}
          className="mb-16 max-w-2xl"
        >
          <div className="mb-4 font-mono text-xs uppercase tracking-[0.3em] text-copper">
            {p.eyebrow}
          </div>
          <h2 className="font-serif text-3xl leading-none tracking-tight text-pine sm:text-5xl">
            {p.titleA} <span className="italic text-copper">{p.titleEm}</span>
          </h2>
        </motion.div>

        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          {p.steps.map((step, i) => (
            <motion.div
              key={step.num}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.12, ease: EASE }}
              data-testid={`process-step-${step.num}`}
              className="group border-t border-copper/30 pt-6 transition-colors duration-500 hover:border-pine"
            >
              <div className="font-mono text-4xl font-light text-copper/60 transition-colors duration-500 group-hover:text-copper sm:text-5xl">
                {step.num}
              </div>
              <h3 className="mt-5 font-serif text-xl text-pine sm:text-2xl">
                {step.name}
              </h3>
              <p className="mt-3 text-sm font-light leading-relaxed text-sand">
                {step.detail}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
